import client from 'client';

type ResonseType = {
    id: string;
    meetingChannel: {
        type: string;
        subtype: string;
        channelId: string;
        token: string;
        uid: string;
        streamId: string;
    };
};

const DUPLICATE_STATUS = 409;
export const DUPLICATE_STATUS_ERROR_MESSAGE = 'AttendeeOnCall';

export const createVideoMeetings = async (
    eventId: number,
    members: number[],
    source: {
        type: string;
        channelId: string;
    }
) => {
    try {
        const response = await client().post<ResonseType>(
            `/api/v2/meetings/events/${eventId}/spontaneousMeetings`,
            {
                members: members.map(memeber => ({ userProfileId: memeber, required: true })),
                source: {
                    type: source.type,
                    id: source.channelId,
                },
                meetingChannel: {
                    type: 'VIDEO',
                    subtype: 'AGORA',
                },
            }
        );
        return response.data;
    } catch (error) {
        if (error?.response?.status === DUPLICATE_STATUS) {
            throw Error(DUPLICATE_STATUS_ERROR_MESSAGE);
        }
        throw Error(error);
    }
};

export const joinVideoCall = async (eventId: number, meetingId: string) => {
    return client().post(`/api/v2/meetings/events/${eventId}/meetings/${meetingId}/joinCall`);
};

export const leaveVideoCall = async (eventId: number, meetingId: string) => {
    return client().post(`/api/v2/meetings/events/${eventId}/meetings/${meetingId}/end`);
};

export const pingApi = async (eventId: number, meetingId: string) => {
    return client().post(`/api/v2/meetings/events/${eventId}/meetings/${meetingId}/ping`);
};
